<template>
  <v-container
    class="px-5"
  >
    <v-row>
      <v-col cols="12">
        <h1 class="mt-0">
          {{ $t('signing.header') }}
        </h1>
        <p class="mb-0">
          {{ $t('signing.desc-1') }}
        </p>
        <p>{{ $t('signing.desc-2') }}</p>
      </v-col>
      <v-col cols="12">
        <h5>{{ $t('signing.contractAgreement') }}</h5>
        <v-checkbox v-model="signing.contractAgreement"
                    class="text-uppercase"
                    @change="$root.updateSigning('contractAgreement', signing.contractAgreement); $root.$v.signing.contractAgreement.$touch();">
          <template v-slot:label @click.stop>
            <span>{{ $t('signing.contractAccept') }}</span> <contract-viewer text="contractTerms" classes="px-2 primary--text" />
          </template>
        </v-checkbox>
      </v-col>
      <v-col cols="12">
        <h5>{{ $t('signing.digitalSignature') }}</h5>
        <p>{{ $t('signing.digitalSignatureDesc-1') }}</p>
        <p>{{ $t('signing.digitalSignatureDesc-2') }}</p>
        <v-row>
          <v-col
            cols="12"
            lg="9"
          >
            <v-row v-if="isCompany">
              <v-col
                cols="12"
                sm="6"
              >
                <custom-input-group
                  :model="signing.firstName"
                  :validator="$root.$v.signing.firstName"
                  :maxlength="41"
                  label="firstName"
                  :disabled="!isCompany"
                  @update:model="$root.updateSigning('firstName', $event)"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <custom-input-group
                  :model="signing.lastName"
                  :validator="$root.$v.signing.lastName"
                  :maxlength="41"
                  label="lastName"
                  :disabled="!isCompany"
                  @update:model="$root.updateSigning('lastName', $event)"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <custom-input-group
                  :model="signing.socSecNr"
                  :validator="$root.$v.signing.socSecNr"
                  :maxlength="11"
                  label="socSecNr"
                  :disabled="!isCompany"
                  @update:model="$root.updateSigning('socSecNr', $event)"
                />
              </v-col>
            </v-row>

            <v-container
              class="pa-0 pt-3"
              fluid
            >
              <v-row>
                <!--v-col
                  v-for="auth in authMethods"
                  :key="auth.name"
                  cols="6"
                  sm="6"
                  md="2"
                >
                  <v-card
                    color="white"
                    light
                    hover
                    ripple
                    class="ok-bank-card pt-2"
                    :class="{ active: selectedMethod === auth.identifier }"
                    @click.native="selectBank(auth.identifier)"
                  >
                    <v-img
                      contain
                      :src="auth.image"
                      :height="'80px'"
                      class="mx-2"
                    />
                    <v-card-actions class="pb-0 px-0">
                      <v-container
                        fluid
                        class="pa-0"
                      >
                        <v-row class="ma-0">
                          <v-col
                            cols="12"
                            class="text-center bank-selection pa-1"
                          >
                            <v-icon
                              v-if="selectedMethod === auth.identifier"
                              small
                            >
                              fa-check-circle
                            </v-icon>
                            <v-icon
                              v-else
                              small
                            >
                              far fa-circle
                            </v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <error-viewer />
                </v-col-->
                <v-col
                  cols="12"
                  class="text-center"
                >
                  <v-btn
                    tile
                    color="primary"
                    :disabled="!isValid || loading"
                    :loading="loading"
                    @click="authSelected"
                  >
                    {{ $t('signing.sign') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapFields } from 'vuex-map-fields'
  import ErrorViewer from '../components/ErrorViewer.vue'
  import ContractViewer from '../views/ContractViewer.vue'

  export default {
    components: {
      'error-viewer': ErrorViewer,
      'contract-viewer': ContractViewer
    },
    /* data: () => ({
      authMethods: [
        {
          'identifier': 'tupas-osuuspankki',
          'name': 'Osuuspankki',
          'image': 'https://www.onnistuu.fi/img/banks/op_white_bgr-14.gif'
        },
        {
          'identifier': 'tupas-nordea',
          'name': 'Nordea',
          'image': 'https://www.onnistuu.fi/img/banks/nordea_button_70x70px.gif'
        },
        {
          'identifier': 'tupas-danske',
          'name': 'Danske Bank',
          'image': 'https://www.onnistuu.fi/img/banks/danskebank.png'
        },
        {
          'identifier': 'tupas-spankki',
          'name': 'S-Pankki',
          'image': 'https://www.onnistuu.fi/img/banks/s-pankki.png'
        },
        {
          'identifier': 'tupas-handelsbanken',
          'name': 'Handelsbanken',
          'image': 'https://www.onnistuu.fi/img/banks/handelsbanken_painike.jpg'
        },
        {
          'identifier': 'tupas-elisa',
          'name': 'Mobiilivarmenne',
          'image': 'https://www.onnistuu.fi/img/banks/elisa.png'
        },
        {
          'identifier': 'tupas-aktia',
          'name': 'Aktia',
          'image': 'https://www.onnistuu.fi/img/banks/aktia.png'
        },
        {
          'identifier': 'tupas-poppankki',
          'name': 'POP Pankki',
          'image': 'https://www.onnistuu.fi/img/banks/POPmaksunappi.png'
        },
        {
          'identifier': 'tupas-sp',
          'name': 'Säästöpankki',
          'image': 'https://www.onnistuu.fi/img/banks/Spmaksunappi.png'
        },
        {
          'identifier': 'tupas-omasp',
          'name': 'Oma Säästöpankki',
          'image': 'https://www.onnistuu.fi/img/banks/omasp.png'
        },
        {
          'identifier': 'tupas-alandsbanken',
          'name': 'Ålandsbanken',
          'image': 'https://www.onnistuu.fi/img/banks/alandsbanken.gif'
        }
      ]
    }), */
    computed: {
      ...mapFields({
        selectedMethod: 'authMethod',
        signing: 'signing',
        loading: 'loading'
      }),
      isCompany: function () {
        return this.$store.getters.client.isCompany
      },
      isValid: function () {
        return this.$store.getters.isValid
      }
    },
    /* created () {
      if (this.authMethods === null) {
        this.$store.dispatch('getAuthMethods').then(response => {
          this.authMethods = response
        }, error => {
          console.log(error)
          // this.$store.commit('setMessage', { type: 'error', text: 'Virhe', clickToDismiss: true })
        })
      }
    }, */
    methods: {
      /* selectBank (selectedMethod) {
        this.selectedMethod = selectedMethod
      }, */
      authSelected () {
        this.$store.dispatch('getVismaUrl')
      }
    },
    beforeRouteLeave (to, from, next) {
      this.$root.$v.signing.$touch()
      next()
    }
  }
</script>
